import * as API from '@/api';

function initialState () {
  return {};
}

const state = initialState ();

// getters
const getters = {};

// actions
const actions = {
  async markRevenuePaid (context, payload) {
    var response = await API.adminRevenue.markRevenuePaid (payload);
    return response;
  },
};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
